<ng-container *transloco="let t">
  <div>
    <nz-page-header class="bg-slate-100" [nzGhost]="false">
      <nz-page-header-title class="text-primary flex items-center gap-2">
        {{ t('agents.title') }}
        <nz-icon
          nz-tooltip
          nzTooltipPlacement="right"
          [nzTooltipArrowPointAtCenter]="true"
          [nzTooltipTitle]="'nav.featureTooltips.agent' | transloco"
          [nzTooltipOverlayStyle]="{
            'max-width': '400px',
            'min-width': '300px',
            'white-space': 'normal',
            'line-height': '1.5'
          }"
          nzType="info-circle"
          nzTheme="outline">
        </nz-icon>
      </nz-page-header-title>
      <nz-page-header-extra>
        <nz-space class="flex flex-col-reverse md:flex-row">
          <div class="pe-3 mt-3 md:mt-0">
            <nz-input-group nzSearch [nzAddOnAfter]="suffixButton" [nzSuffix]="inputClearTpl">
              <input
                type="text"
                nz-input
                [placeholder]="t('agents.searchPlaceholder')"
                (keydown.enter)="this.search()"
                [(ngModel)]="agentSearch" />
            </nz-input-group>
            <ng-template #inputClearTpl>
              <span
                *ngIf="agentSearch"
                nz-icon
                class="ant-input-clear-icon"
                nzTheme="fill"
                nzType="close-circle"
                (click)="reset()">
              </span>
            </ng-template>
            <ng-template #suffixButton>
              <button
                nz-button
                nzType="primary"
                nzSearch
                (click)="search()">
                {{ t('agents.searchBtn') }}
              </button>
            </ng-template>
          </div>
          <div>
            <button
              *appHasAnyPrivilege="'AGENT.ADD'"
              nz-button
              nzType="primary"
              routerLink="/admin/agents/add"
              class="flex items-center justify-center gap-2">
              <lucide-icon name="user-plus" class="icon-size"></lucide-icon>
              {{ t('agents.addBtn') }}
            </button>
          </div>
        </nz-space>
      </nz-page-header-extra>
    </nz-page-header>
  </div>

  <div class="my-4">
    <nz-table
      #basicTable
      [nzData]="allCustomers"
      [nzShowSizeChanger]="pageSize.length > 5"
      [nzPageSizeOptions]="pageSize.pageSizeOptions"
      [nzBordered]="true"
      [nzFrontPagination]="false"
      [nzTotal]="pageSize.length"
      [nzPageSize]="pageSize.pageSize"
      [nzPageIndex]="pageSize.pageIndex"
      (nzQueryParams)="onTableParamsChange($event)"
      [nzScroll]="{ x: '1100px' }">
      <thead>
        <tr>
          <th [nzSortFn]="sortColumn.compareName" nzWidth="200px">{{ t('agents.table.name') }}</th>
          <th nzWidth="100px">{{ t('agents.table.status') }}</th>
          <th [nzSortFn]="sortColumn.compareDate" nzWidth="120px">
            {{ t('agents.table.createdDate') }}
          </th>
          <th nzWidth="170px" *appHasAnyPrivilege="'AGENT.EDIT'">
            {{ t('agents.table.action') }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let data of basicTable.data">
          <td class="capitalize">{{ data.name }}</td>
          <td>
            <nz-tag *ngIf="data.active" [nzColor]="'green'">{{ t('agents.status.active') }}</nz-tag>
            <nz-tag *ngIf="!data.active" [nzColor]="'red'">{{ t('agents.status.inactive') }}</nz-tag>
          </td>
          <td>{{ data.createdAt | date }}</td>
          <td *appHasAnyPrivilege="'AGENT.EDIT'" class="flex flex-row gap-3">
            <button
              *appHasAnyPrivilege="'AGENT.EDIT'"
              nz-button
              nzType="default"
              nzSize="small"
              [routerLink]="'/admin/agents/edit/' + data._id"
              class="flex items-center justify-center gap-2">
              <lucide-icon name="pencil" class="icon-size"></lucide-icon>
              {{ t('agents.editBtn') }}
            </button>
          </td>
        </tr>
      </tbody>
    </nz-table>
  </div>
</ng-container>